import { render, staticRenderFns } from "./FieldsOfStudy.vue?vue&type=template&id=5216dc1d&scoped=true"
import script from "./FieldsOfStudy.vue?vue&type=script&lang=js"
export * from "./FieldsOfStudy.vue?vue&type=script&lang=js"
import style0 from "./FieldsOfStudy.vue?vue&type=style&index=0&id=5216dc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216dc1d",
  null
  
)

export default component.exports